export const formatConfirmationCode = val => {
  const onlyDigits = val.replace(/\D/g, '').replace(/(\d{6})\d+?$/, '$1');
  const formatted = onlyDigits.replace(/(\d{3})(\d)/, '$1-$2');
  return { formatted, onlyDigits };
};

export default { formatConfirmationCode };
